import React, { useState } from "react";
import { useBaseList } from "../../components/fx";
import { useControlListStore } from "../../controllers/ControlListController";

const Controls = () => {

    const { renderList } = useBaseList({ storeHook: useControlListStore, formRoute: '/control' });
    return (
        <>
            {renderList()}
        </>
    );
}

export default Controls;
